import React from 'react';
import { Box, Card, CardContent, Typography, LinearProgress } from '@mui/material';
import { colors, fonts, spacing, borderRadius, shadows } from '../../constants';

/**
 * MetricsCard Component
 * Individual metric card component
 */
const MetricsCard = ({
  label,
  value,
  subValue,
  color,
  showProgress = false,
  progressValue,
}) => {
  // Extract numeric value from string if needed (e.g., "63.2%" -> 63.2)
  const getProgressValue = () => {
    if (progressValue !== undefined) {
      return progressValue;
    }
    if (typeof value === 'number') {
      return value;
    }
    if (typeof value === 'string') {
      const numericValue = parseFloat(value.replace('%', ''));
      return isNaN(numericValue) ? 0 : numericValue;
    }
    return 0;
  };

  return (
    <Box sx={{ flex: '1 1 20%', minWidth: { xs: '100%', sm: 'calc(50% - 6px)', md: 0 } }}>
      <Card sx={{ borderRadius: borderRadius.md, boxShadow: shadows.md, height: '100%' }}>
        <CardContent sx={{ p: spacing.xs }}>
          <Typography variant="body2" sx={{ color: colors.textSecondary, mb: spacing.xs, fontSize: fonts.fontSizeSm }}>
            {label}
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: fonts.weightBold, mb: spacing.xs, fontSize: fonts.fontSize2xl, color: color }}>
            {value}
          </Typography>
          {subValue && (
            <Typography variant="body2" sx={{ color: colors.textSecondary, fontSize: fonts.fontSizeSm }}>
              {subValue}
            </Typography>
          )}
          {showProgress && (
            <LinearProgress
              variant="determinate"
              value={getProgressValue()}
              sx={{
                height: 6,
                borderRadius: borderRadius.sm,
                backgroundColor: colors.backgroundSoft,
                '& .MuiLinearProgress-bar': {
                  backgroundColor: color,
                },
              }}
            />
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default MetricsCard;
